import apiBaseUrl from '../../utils/config.js';

class OfficeHoursService {
  constructor() {
    this.baseUrl = `${apiBaseUrl}/office-hours`;
  }

  getToken() {
    return localStorage.getItem('jwt');
  }

  getAuthHeaders() {
    const token = this.getToken();
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  }

  async #request(endpoint, method = 'GET', body = null) {
    const options = {
      method,
      headers: this.getAuthHeaders(),
    };

    if (body) {
      options.body = JSON.stringify(body);
    }

    try {
      const response = await fetch(`${this.baseUrl}${endpoint}`, options);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Request failed: ${errorText}`);
      }

      return await response.json();
    } catch (error) {
      console.error(`Error in ${method} ${endpoint}:`, error);
      throw error;
    }
  }

  async saveOfficeHours(officeHours) {
    return this.#request('/save', 'POST', officeHours);
  }

  async saveBulkOfficeHours(officeHoursBulkRequest) {
    return this.#request('/save-bulk', 'POST', officeHoursBulkRequest);
  }

  async getAllOfficeHours() {
    return this.#request('/all');
  }

  async getOfficeHoursById(id) {
    try {
      return await this.#request(`/${id}`);
    } catch {
      return null;
    }
  }

  async getOfficeHoursByOfficeId(officeId) {
    return this.#request(`/office/${officeId}`);
  }

  async getOfficeHoursByOfficeIdAndDate(officeId, date) {
    return this.#request(`/office/${officeId}/date/${date}`);
  }

  async deleteOfficeHours(id) {
    try {
      await this.#request(`/delete/${id}`, 'DELETE');
      return true;
    } catch {
      return false;
    }
  }

  async validateAppointment(officeId, date, time) {
    return this.#request(`/validate?officeId=${officeId}&date=${date}&time=${time}`);
  }

  async filterOfficeHours({ officeId, date }) {
  const params = new URLSearchParams();

  if (officeId) params.append('officeId', officeId);
  if (date) params.append('date', date);

  const query = params.toString();

  return this.#request(`/filter${query ? `?${query}` : ''}`);
}

async updateOfficeHours(id, officeHours) {
  return this.#request(`/update/${id}`, 'PUT', officeHours);
}

}

export default OfficeHoursService;